module.exports = __webpack_public_path__ + "img/1454341618.2527cfe2.jpg";